export enum MingaAffiliationType {
  PARTNER = 'Partner',
  DISTRICT = 'District',
}
